export interface ISettingLink {
  title: string;
  icon: string;
  description: string;
  path: string[];
}

export interface ISettingsLinksBlock {
  title: string;
  links: ISettingLink[];
}

export const settingsLinksBlocks: ISettingsLinksBlock[] = [
  {
    title: 'General',
    links: [
      {
        title: 'Organisation Details',
        description: 'Visit this page to ensure your account details in Pravo are current.',
        icon: 'ic-organisation-20',
        path: ['settings', 'my-organisation'],
      },
      {
        title: 'Users and Permissions',
        description: 'Are you struggling to manage user access and permissions? Take charge of your team\'s access with Pravo\'s easy-to-use access permissions.',
        icon: 'ic-accounts-20',
        path: ['settings', 'accounts']
      },
      {
        title: 'Agent Details',
        description: 'To ensure uninterrupted and efficient system usage, taking control of your ASIC account details is crucial.',
        icon: 'ic-asic-black-white-20',
        path: ['settings', 'agent-settings']
      },
      {
        title: 'Branding',
        description: 'Elevate your documents by adding your logo and a footer to create customised cover pages and improve client communication.',
        icon: 'ic-upload-file-20',
        path: ['settings', 'branding'],
      },
    ]
  }, {
    title: 'Workflows and Integrations',
    links: [
      {
        title: 'Manage Tags',
        description: "Start using tags in Pravo to filter entities with lightning speed and group them efficiently. Create Tags for your entities now.",
        icon: 'ic-tags-20',
        path: ['settings', 'tags'],
      },
      {
        title: 'Integrations',
        description: `Pravo has partnered with leading eSigning and practice management providers to ensure that we address all of Pravo's users' needs. Click "Integrations" to learn more.`,
        icon: 'ic-link-20',
        path: ['settings', 'integrations'],
      },
      {
        title: 'Document Settings',
        description: "Have the freedom to customise your ASIC forms and annual statement settings based on your firm's needs. Get started by reviewing the list.",
        icon: 'ic-settings-20',
        path: ['settings', 'document-settings'],
      },
      {
        title: 'Cover Letter Templates',
        description: "Make the most of Pravo's extensive document templates to personalize your client communication and create powerful connections.",
        icon: 'ic-file-20',
        path: ['settings', 'cover-letter-templates'],
      },
      {
        title: 'Email Settings',
        description: "Send emails to your clients directly from Pravo by customising your email settings.",
        icon: 'ic-settings-20',
        path: ['settings', 'email-settings'],
      },
      {
        title: 'Email Templates',
        description: "Utilise Pravo's diverse email templates to assertively personalise your communication with clients and establish a more impactful connection.",
        icon: 'ic-mail-20',
        path: ['settings', 'email-templates'],
      },
      {
        title: 'SMS Templates',
        description: "Enhance client engagement by customizing your SMS templates before sending reminders. Personalise the templates for a more meaningful connection with your clients.",
        icon: 'ic-message-20',
        path: ['settings', 'sms-templates'],
      },
      {
        title: 'Reminders',
        description: "Struggling to keep up with ASIC payment and lodgement deadlines? Take control and never miss a deadline again by using Pravo's effective reminder feature.",
        icon: 'ic-bell-20',
        path: ['settings', 'reminders'],
      },
    ]
  },
];

